


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class CloneDialog extends Vue {
  @Prop()
  private title!: string

  @Prop({ default: 'Bestätigen' })
  private confirmButtonText!: string

  private cloneOption = '1'

  private dialog: boolean = false
  private evaluationId = ''

  public open(evaluationId: string) {
    this.evaluationId = evaluationId
    this.dialog = true
  }

  private confirm() {
    this.$emit('confirm', this.cloneOption, this.evaluationId)
    this.dialog = false
  }

  private cancel() {
    this.$emit('cancel')
    this.dialog = false
  }
}
